import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'
import { getServiceReducers } from 'src/helpers/ReduxHelpers'
import { QuizzQuestionWeek } from 'src/types'

import type { RootState } from '../store'

import { actionTypes } from './types'

// eslint-disable-next-line @typescript-eslint/ban-types
export type QuizzState = {
  quizzValues: any
  currentQuizzIndex: number
  typeOfUser: string
}

//
// Initial state
//
const initialState: QuizzState = {
  quizzValues: {
    question1: '',
    question2: '',
    question3: QuizzQuestionWeek.PER_WEEK_1,
    question4: 5,
    question5: '',
    question6: QuizzQuestionWeek.PER_WEEK_1,
    question7: 5,
    question8: '',
    question9: '',
    question9_alt: QuizzQuestionWeek.PER_WEEK_1,
    question10: 5,
    question11: '',
    question12: QuizzQuestionWeek.PER_WEEK_1,
    question13: 20,
    question14: '',
    question14_bis: '',
    question15_1: QuizzQuestionWeek.PER_WEEK_1,
    question15_2: 5,
    question15_bis_1: QuizzQuestionWeek.PER_WEEK_1,
    question15_bis_2: 5,
    question16: '',
    question17: '',
  },
  currentQuizzIndex: 0,
  typeOfUser: '',
}

const quizzReducers = getServiceReducers('quizz')

//
// Slice (Actions & Reducers)
//
const slice = createSlice({
  name: 'quizz',
  initialState,
  reducers: {
    init: () => undefined,
    setCurrentQuizzIndex: (state, action: actionTypes.setCurrentQuizzIndex) => {
      state.currentQuizzIndex = action.payload
    },
    setTypeOfUser: (state, action: actionTypes.setTypeOfUser) => {
      state.typeOfUser = action.payload
    },
    setStepValues: (state, action: actionTypes.setQuizzValues) => {
      state.quizzValues = {
        ...state.quizzValues,
        [action?.payload?.name ?? '']: action.payload.value,
      }
    },
    //
    quizzRequest: quizzReducers.request,
    quizzSuccess: quizzReducers.success,
    quizzError: quizzReducers.error,
    quizzReset: quizzReducers.reset,
  },
  extraReducers: {
    [HYDRATE]: (_state, action) => {
      return action.payload.quizz
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//
const root = (state: RootState) => state.quizz
const quizzValues = (state: RootState) => root(state).quizzValues
const currentQuizzIndex = (state: RootState) => root(state).currentQuizzIndex
const typeOfUser = (state: RootState) => root(state).typeOfUser

export const selectors = {
  quizzValues,
  currentQuizzIndex,
  typeOfUser,
}
